import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import type Context from '@alltrails/types/Context';
import { handleTinuitiCookie, trackTinuitiPageView } from '../../utils/marketingTracking/tinuitiUtils';

const DEFER_ANALYTICS_MS = 500;

const useTinuitiPixel = () => {
  const user = useSelector((state: { context: Context }) => state.context.currentUser) || null;
  const userId = user?.id?.toString();

  useEffect(() => {
    const runAfterFirstPaint = () => {
      handleTinuitiCookie();
      trackTinuitiPageView(userId);
    };

    if (typeof requestIdleCallback !== 'undefined') {
      const id = requestIdleCallback(runAfterFirstPaint, { timeout: DEFER_ANALYTICS_MS });
      return () => cancelIdleCallback(id);
    } else {
      const id = setTimeout(runAfterFirstPaint, DEFER_ANALYTICS_MS);
      return () => clearTimeout(id);
    }
  }, [userId]);
};

export default useTinuitiPixel;
